export default __webpack_public_path__ + "static/media/michelle-vertical-mobile.c78bef36.png";